<template>
  <div class="text-center">
    <v-menu open-on-hover>
      <template v-slot:activator="{ props }">
        <router-link :to="categoriaLink" v-slot="{ href, route, navigate }">
          <v-btn
            class="text-none text-subtitle-1"
            :color="textColor"
            variant="text"
            v-bind="props"
            :href="href"
            @click="navigate()"
          >
            {{ item }}{{ route.CategoriaPage }}
            <span v-if="filhas.length > 0"
              ><v-icon right>mdi-arrow-down</v-icon></span
            >
          </v-btn>
        </router-link>
      </template>
      <v-list v-if="filhas.length > 0" max-height="450" class="custom-scroll">
        <v-list-item v-for="(item, index) in filhas" :key="index">
          <v-list-item-title>
            <router-link
              :to="categoriaLinkFilha + item.codigo"
              v-slot="{ href, route, navigate }"
            >
              <v-btn
                class="text-none text-subtitle-1"
                color="black"
                variant="text"
                :href="href"
                @click="navigate()"
              >
                {{ item.nome }}{{ route.CategoriaPage }}
              </v-btn>
            </router-link>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["item", "codigo", "filhas", "textColor"],
  components: {},
  data() {
    return {};
  },
  computed: {
    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    categoriaLink() {
      return (
        "/" +
        this.tipo +
        "/" +
        this.loja +
        "/produtos/" +
        "categorias/" +
        this.codigo
      );
    },
    categoriaLinkFilha() {
      return "/" + this.tipo + "/" + this.loja + "/produtos/" + "categorias/";
    },
  },
  methods: {},
  created() {},
};
</script>

<style scoped>
.custom-scroll {
  overflow-y: auto;
}

.custom-scroll::-webkit-scrollbar {
  width: 8px;
}

.custom-scroll::-webkit-scrollbar-track {
  background: #f0f0f0; /* track background */
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: var(--primary-color); /* thumb color */
  border-radius: 4px;
  border: 2px solid #f0f0f0; /* creates padding around thumb */
}

/* Optional: For Firefox */
.custom-scroll {
  scrollbar-color: var(--primary-color) #f0f0f0;
  scrollbar-width: thin;
}
</style>
